import { translationApi, TranslationApi } from "./TranslationsApi";

export class TranslationsService {
    private api : TranslationApi
    private translations: Record<string, string> = {};
    private loaded = false;

    constructor(api : TranslationApi) {
        this.api = api;
    }
    
    public getTranslation(key: string): string {
        if (!this.loaded) {
            console.warn(`Translation requested before loading: ${key}`);
            return key;
        }
        
        return this.translations[key] || key;
    }

    public async loadTranslations(): Promise<void> {
        if (this.loaded) {
            return;
        }
        
        try {
            const result = await this.api.getTranslations();
            this.translations = {};
            for (const item of result) {
                this.translations[item.key] = item.translation;
            }
            this.loaded = true;
        } catch (err) {
            console.error('TranslationsService: Translations load failed', err);
        }
    }
}

export const translationService : TranslationsService = new TranslationsService(translationApi);